<div *ngIf="showFormByUser==false">
    <div class="row mt-4">
      <div class="col-xxl-12 col-md-12 col-lg-12 info_table">
        <app-advance-line [step]="step" [currentStep]="currentStep"></app-advance-line>
        <br><br>
        <div class="table-responsive">
          <table class="table" aria-describedby="mydesc">
            <thead>
            <tr>
              <th>ID trámite</th>
              <th>Fecha radicación</th>
              <th>Estado trámite</th>
              <th>Fecha Estado</th>
              <th>Acciones</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of allByUser">
              <td>{{item.filedNumber}}</td>
              <td>{{item.date | date: 'dd/MM/yyyy hh:mm a'}}</td>
              <td>{{item.status}}</td>
              <td>{{item.statusDate | date: 'dd/MM/yyyy hh:mm a'}}</td>
              <td class="text-justify">
                <a (click)="getTramiteActual(item.id)" *ngIf="item.status == 'Solicitar más información'"><span class="govco-edit-1" style="font-size: 17px">Editar Trámite</span></a>
                <a *ngIf="isValidation(item.status)"><span class="govco-book-reader" style="font-size: 17px">En validación</span></a>
                <a (click)="showLicencia(item.licenseId)" *ngIf="item.status == 'Firma Aprobación' || item.status == 'Firma Negación'"><span class="govco-file-pdf" style="font-size: 17px">Ver documento</span></a>
                <a *ngIf="item.status == 'Licencia Revocada'"><span class="govco-file-prescription" style="font-size: 17px">Licencia revocada</span></a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

</div>

<div class="row" >
  <div class="col-sm-12 col-md-8">
    <app-edit-info [tramiteActual]="tramiteSeleccionado" [trackingTramiteActual]="trackingTramiteActual" *ngIf="showFormByUser==true"></app-edit-info>
  </div>
</div>

<div *ngIf="showFormByUser==true">
  <br><br>
  <button type="button" class="btn-govco fill-btn-govco"
          style="margin-right: 10px"
          (click)="cancelFrm()">Volver
  </button>
</div>

